/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useCallback, useState } from 'react'
import { createContainer } from 'unstated-next'
import Web3 from '.'
import { ethers } from 'ethers'

interface useWeb3MethodProps {
  currentAccount: string | null | undefined
  walletBalance: string
  waitForTx: (
    tx: string
  ) => Promise<ethers.providers.TransactionReceipt | undefined>
  updateWalletBalance: () => Promise<void>
}

function useWeb3Method(): useWeb3MethodProps {
  const [walletBalance, setWalletBalance] = useState('0')

  const { currentAccount, library } = Web3.useContainer()

  const canRun = useCallback(() => {
    if (!currentAccount) return false
    if (!library) return false
    if (!library.getSigner()) return false
    return true
  }, [currentAccount, library])

  const getWalletBalance = useCallback(async () => {
    if (!canRun()) return '0'
    const bn = await library.getBalance(currentAccount)
    return bn.toString()
  }, [currentAccount, canRun, library])

  const updateWalletBalance = useCallback(async () => {
    if (!canRun()) return
    const b = await getWalletBalance()
    setWalletBalance(b)
  }, [canRun, setWalletBalance, getWalletBalance])

  const waitForTx = useCallback(
    async (tx: string) => {
      if (!library) return
      const txReceipt: ethers.providers.TransactionReceipt =
        await library.waitForTransaction(tx)
      return txReceipt
    },
    [library]
  )

  return {
    currentAccount,
    walletBalance,
    waitForTx,
    updateWalletBalance,
  }
}

const Web3Method = createContainer(useWeb3Method)

export default Web3Method
